<!-- <ion-header>
<app-order-page-toolbar
  (backClick)="dismiss()"
  [hideElements]="loading"
  [preorderType]="order?.preorder?.type"
  title="{{ 'payment_modal.title' | translate }}"
></app-order-page-toolbar>
</ion-header> -->
<ion-content>
	<ion-row>
		<ion-col size="12">
			<div class="header">
				<ion-icon (click)="dismiss()" class="back-icon" src="../../../assets/topgolf/back.svg"></ion-icon>

				<ion-icon (click)="dismiss()" class="close-icon" src="../../../assets/topgolf/cross.svg"></ion-icon>
			</div>
		</ion-col>
	</ion-row>
	@if (normalOrder?.giftCard) {
		<ion-row>
			<ion-col size="12">
				@if (normalOrder?.giftCard) {
					<div class="added-gift delete-promo">
						<div class="header-gift">
							{{ normalOrder?.giftCard?.balance }}<br />
							{{ normalOrder?.currency }}
						</div>
						<div class="inner-text-gift">
							<h3>{{ 'add_gift_card.text_add' | translate }}</h3>
							<p>
								{{ normalOrder?.giftCard?.balance }} {{ normalOrder?.currency }}
								{{ 'add_gift_card.text_subtitle_add' | translate }}
							</p>
						</div>
						<div class="delete-items-section">
							<ion-img src="../../../assets/topgolf/header_logo.svg"></ion-img>
						</div>
					</div>
				}
				<div class="info-section">
					<ion-icon src="../../../assets/topgolf/info-section.svg"></ion-icon>
					<p>
						{{ 'add_gift_card.alert' | translate }}
					</p>
				</div>
			</ion-col>
		</ion-row>
	}
	<ion-row>
		<ion-col size="12">
			<h1 class="ion-margin header-msg">
				{{ 'payment_modal.message' | translate }}
			</h1>
			<div class="separator"></div>
		</ion-col>
		<ion-col size="12">
			<ion-radio-group (ionChange)="loadPayment()" [(ngModel)]="selectedPaymentMethod" [disabled]="loading">
				@for (method of paymentMethods; track method) {
					<ion-item [disabled]="loading" class="payment-method-row" lines="none">
						<ion-label>{{ method | translate }}</ion-label>
						<ion-radio [value]="method" slot="start"></ion-radio>
						<ion-icon class="icon-size" size="large" slot="end" src="/assets/icon/{{ method }}.svg"></ion-icon>
					</ion-item>
				}
			</ion-radio-group>

			@if (selectedPaymentMethod === pm.ADYEN) {
				<div id="customCard-container">
					<label>
						<span>Card number:</span>
						<span class="input_data" data-cse="encryptedCardNumber"></span>
					</label>
					<label>
						<span>Expiry date:</span>
						<span class="input_data" data-cse="encryptedExpiryDate"></span>
					</label>
					<label>
						<span>CVV/CVC:</span>
						<span class="input_data" data-cse="encryptedSecurityCode"></span>
					</label>
					<button [class.hidden]="isAdyenLoading" id="payButton">Pay</button>
					@if (isAdyenLoading) {
						<ion-spinner></ion-spinner>
					}
				</div>
			}
			@if (selectedPaymentMethod === pm.GPAY) {
				<div id="gpay-container"></div>
			}
			@if (selectedPaymentMethod === pm.APAY) {
				<div id="applepay-container"></div>
			}

			@if (selectedPaymentMethod) {
				<div [class.ion-hide]="loading" class="payment-input">
					@if (selectedPaymentMethod == pm.CREDIT_CARD && venue && venue.vrPaymentEnabled) {
						<form [action]="vrUrl" class="paymentWidgets" data-brands="MASTER VISA"></form>
					}
					@if (selectedPaymentMethod == pm.CREDIT_CARD && !venue.vrPaymentEnabled && venue.ppFullIntegrationEnabled) {
						<div id="paypal-cc-button"></div>
					}
					@if (selectedPaymentMethod == pm.GPAY) {
						<form [action]="vrUrl" class="paymentWidgets" data-brands="GOOGLEPAY"></form>
					}
					@if (selectedPaymentMethod == pm.APAY) {
						<form [action]="vrUrl" class="paymentWidgets" data-brands="APPLEPAY"></form>
					}
					@if (selectedPaymentMethod == pm.PAYPAL) {
						<div id="paypal-button"></div>
					}
					@if (selectedPaymentMethod == pm.WORLDLINE) {
						<div class="cash-block">
							<ion-button (click)="loadWordline()">{{ pm.WORLDLINE | translate }}</ion-button>
						</div>
					}
					@if (selectedPaymentMethod == pm.SOFORTBANKING) {
						<div id="klarna-button"></div>
					}
					@if (selectedPaymentMethod == pm.CASH) {
						<div class="cash-block">
							<ion-button (click)="loadCashPay()">{{ pm.CASH | translate }}</ion-button>
						</div>
					}
					@if (
						selectedPaymentMethod == pm.POSTFINANCE ||
						selectedPaymentMethod == pm.BONCARD ||
						selectedPaymentMethod == pm.TWINT ||
						selectedPaymentMethod == pm.POSTFINANCE_CARD ||
						selectedPaymentMethod == pm.LUNCHECK ||
						selectedPaymentMethod == pm.CARD_WORLDLINE ||
						selectedPaymentMethod == pm.REKA
					) {
						<div class="cash-block">
							<!-- <ion-button (click)="goToPayment()">{{pm.POSTFINANCE | translate}}</ion-button> -->
							<a (click)="dismiss()" [href]="payment?.walleePayment?.url" class="payment-link" target="_blank"
								>{{ 'payment_modal.pay_with' | translate }} {{ selectedPaymentMethod | translate }}
							</a>
						</div>
					}
					<!-- <div *ngIf="selectedPaymentMethod == pm.CCV" class="cash-block">
          <div class="payment-link" (click)="navigateCvv(payment.url)" (click)="dismiss()">
            {{ 'payment_modal.pay_with' | translate }} {{ selectedPaymentMethod | translate }}
          </div>
        </div> -->
				</div>
			}
			<div class="separator bottom-separator"></div>
			@if (selectedPaymentMethod == pm.CREDIT_CARD) {
				<div #iframeContainer style="width: 100%; height: 100vh">
					<!-- The iframe will be dynamically inserted here -->
				</div>
			}
		</ion-col>
	</ion-row>
	<ion-row class="ion-justify-content-center">
		<ion-spinner [class.ion-hide]="!loading"></ion-spinner>
	</ion-row>
</ion-content>
